import React, { useState, useEffect } from 'react';
import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { useTranslation } from 'react-i18next';

const InputAutocomplete = ({
    dataProvider, searchkey = "name", labelkey = "label", filters = {}, project = [], distinct = [],  label = 'Select', onChange = () => { },
    name, invalid, variant = "outlined", placeholder, disabled, readonly, required, startDecorator, endDecorator, multiple = false,
    style, value, size = 'regular', preload = false, ctaText = ''
}) => {
    const { t } = useTranslation();
    const [inputValue, setInputValue] = useState('');
    const { items, loading, loadAll } = useDataProvider(dataProvider);

    // console.info('preload fuori', preload)
    useEffect(() => {
        // if (preload) {
        //     console.info('preload di ', label, dataProvider)
        // }
        if (inputValue.length < 2 && !preload) {
            return;
        }
        const fetch = async () => {
            try {
                const compoundfilters = {};
                const externalfilters = filters?.items ?? [];
                compoundfilters.items = [...externalfilters, { field: searchkey, operator: "contains", value: inputValue }];
                compoundfilters.project = project;
                compoundfilters.distinct = distinct;

                loadAll(compoundfilters);
            } catch (e) {
                console.error('Errore nel caricamento dei dati:', e);
            }
        };

        const debounce = setTimeout(fetch, 300);
        return () => clearTimeout(debounce);
    }, [inputValue, preload]);

    const computedOptions = () => {
        return items ?? value ?? null;
    }

    return (
        <Autocomplete
            multiple={multiple}
            id={name}
            name={name}
            error={invalid}
            onChange={(e, v) => {
                onChange(v);
            }}
            variant={variant}
            className="form-element-field form-element-field-autocomplete"
            size={size}

            placeholder={t(placeholder)}
            disabled={disabled}
            readOnly={readonly}
            required={required}

            startDecorator={startDecorator}
            endDecorator={endDecorator}

            label={label}
            options={ computedOptions() }
            value={value}

            getOptionLabel={(option) => {
                if (Array.isArray(labelkey)) {
                    return option[labelkey[0]]+" "+option[labelkey[1]]
                }
                console.info('devo disegnare sta fottuta option', option)
                return option[labelkey] || '';
            }}
            loading={loading}
            onInputChange={(_, value) => {
                //console.info('onInputChange', _, value)
                setInputValue(value);
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}
            sx={style}
            noOptionsText={inputValue === '' ? (ctaText ? ctaText : t('Type to search')) : t('No options found')}
        />
    );
}

export default InputAutocomplete;